import { useStore } from 'effector-react'

import {
  $participantList,
  $totalCountOfParticipantList,
  getParticipantList,
  participantListMounted,
} from './model'
import { ParticipantRequest } from './types'

export const useParticipantList = () => {
  const participantList = useStore($participantList)

  const loading = useStore(getParticipantList.pending)

  const totalCountOfParticipantList = useStore($totalCountOfParticipantList)

  const onChangeParticipantList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
  }: ParticipantRequest) => {
    participantListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters,
    })
  }

  return {
    participantList,
    totalCountOfParticipantList,
    loading,
    onChangeParticipantList,
  }
}
